<h1 class="text-xl font-semibold text-gray-900 mb-6">Card Transactions</h1>

<!-- Filters -->
<div class="mb-6 p-4 bg-white rounded-xl shadow-sm border border-gray-200">
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[minmax(0,2fr)_minmax(0,1.5fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1fr)_auto] gap-3 items-end"
  >
    <div class="relative">
      <label for="cardTxUuid" class="block mb-1 text-xs font-medium text-gray-600">Transaction ID</label>
      <input
        id="cardTxUuid"
        type="text"
        [(ngModel)]="txUuid"
        (ngModelChange)="onTextFilterChange()"
        placeholder="e.g. 3f2a9c1e-5b7d-…"
        [ngClass]="{ 'border-red-400! focus:ring-red-400!': uuidInvalid }"
        class="w-full h-10 px-3 border border-gray-300 rounded-lg bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      />
      <p
        *ngIf="uuidInvalid"
        class="absolute left-0 top-full mt-0.5 text-xs text-red-500"
      >
        Not a valid UUID
      </p>
    </div>

    <div>
      <label for="cardTxMerchant" class="block mb-1 text-xs font-medium text-gray-600">Merchant</label>
      <input
        id="cardTxMerchant"
        type="text"
        [(ngModel)]="merchant"
        (ngModelChange)="onTextFilterChange()"
        placeholder="e.g. amazon"
        class="w-full h-10 px-3 border border-gray-300 rounded-lg bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      />
    </div>

    <div>
      <label for="cardTxType" class="block mb-1 text-xs font-medium text-gray-600">Type</label>
      <select
        id="cardTxType"
        [(ngModel)]="transactionType"
        (ngModelChange)="applyFilters()"
        class="w-full h-10 px-3 border border-gray-300 rounded-lg bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      >
        <option value="">All types</option>
        <option *ngFor="let type of transactionTypes" [value]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <div>
      <label for="cardTxStart" class="block mb-1 text-xs font-medium text-gray-600">From</label>
      <input
        id="cardTxStart"
        type="date"
        [(ngModel)]="startDate"
        (ngModelChange)="applyFilters()"
        [max]="endDate"
        class="w-full h-10 px-3 border border-gray-300 rounded-lg bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      />
    </div>

    <div>
      <label for="cardTxEnd" class="block mb-1 text-xs font-medium text-gray-600">To</label>
      <input
        id="cardTxEnd"
        type="date"
        [(ngModel)]="endDate"
        (ngModelChange)="applyFilters()"
        [min]="startDate"
        class="w-full h-10 px-3 border border-gray-300 rounded-lg bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      />
    </div>

    <button
      (click)="clearFilters()"
      [disabled]="!hasFilters"
      class="h-10 px-4 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
    >
      Clear
    </button>
  </div>
</div>

<div
  *ngIf="errorMessage"
  class="mb-4 text-sm text-red-500 bg-red-50 border border-red-200 rounded p-2"
>
  {{ errorMessage }}
</div>

<div class="overflow-x-auto bg-white shadow-md rounded-lg">
  <table class="min-w-full divide-y divide-gray-300">
    <thead class="bg-gray-50">
      <tr>
        <th
          scope="col"
          class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Date
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          ID
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Type
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Merchant
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Amount
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Status
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Merchant category
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Merchant country
        </th>
        <th
          scope="col"
          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        >
          Decline reason
        </th>
      </tr>
    </thead>

    <tbody
      class="divide-y divide-gray-200 bg-white"
      *ngIf="cardTransactions?.length; else loading"
    >
      <tr *ngFor="let transaction of cardTransactions">
        <td
          class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6"
        >
          {{ transaction.created_at | date: "dd/MM/yyyy HH:mm" }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
          {{ transaction.uuid }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
          {{ transaction.transaction_type }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
          {{ transaction.merchant }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {{ transaction.amount }}
          <span
            *ngIf="
              transaction.transaction_type === 'CARD_PAYMENT' &&
              transaction.local_currency_code !== 'USD'
            "
          >
            ({{ transaction.local_currency_amount }}
            {{ transaction.local_currency_code }})
          </span>
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm">
          <span
            [ngClass]="{
              'bg-green-500': transaction.status == 'SUCCEEDED',
              'bg-red-500': transaction.status == 'FAILED',
              'bg-cyan-500': transaction.status == 'NOT_STARTED',
              'bg-yellow-400': transaction.status == 'REFUNDED',
              'bg-yellow-500': transaction.status == 'RETURNED',
              'bg-blue-500': transaction.status == 'PROCESSING',
            }"
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white"
          >
            {{ transaction.status }}
          </span>
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {{ transaction.merchant_category }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {{ transaction.merchant_country }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {{ transaction.decline_reason }}
        </td>
      </tr>
    </tbody>

    <ng-template #loading>
      <tbody class="divide-y divide-gray-200 bg-white">
        <tr>
          <td colspan="9" class="py-6 text-center">
            <div
              *ngIf="submitted; else noResults"
              class="flex justify-center items-center space-x-2"
            >
              <div
                class="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"
              ></div>
              <span class="text-gray-500">Loading data...</span>
            </div>
            <ng-template #noResults>
              <span class="text-gray-500"
                >Sorry, we couldn't find any results</span
              >
            </ng-template>
          </td>
        </tr>
      </tbody>
    </ng-template>
  </table>
</div>

<!-- Pagination -->
<nav class="mt-8 flex items-center justify-center">
  <div class="inline-flex rounded-md shadow-sm -space-x-px">
    <button
      (click)="goToPreviousPage()"
      [disabled]="!previousPageUrl"
      class="px-3 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 rounded-l-md disabled:opacity-50"
    >
      Prev
    </button>
    <button
      *ngFor="let page of pageNumbers"
      (click)="page !== '...' && loadCardTransactions(page)"
      [disabled]="page === '...' || currentPage === page"
      [ngClass]="{
        'bg-indigo-500 text-white font-semibold': currentPage === page,
        'bg-white text-gray-700': currentPage !== page && page !== '...',
        'cursor-default': page === '...',
      }"
      class="px-4 py-2 border border-gray-300 text-sm font-medium"
    >
      {{ page }}
    </button>
    <button
      (click)="goToNextPage()"
      [disabled]="!nextPageUrl"
      class="px-3 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 rounded-r-md disabled:opacity-50"
    >
      Next
    </button>
  </div>
</nav>
